import React from 'react';

export interface SectionHeadProps {
  /** The heading's id: the section's anchor (`#budget`) and the name its region is labelled by. */
  id: string;
  title: string;
  /** The period the section reads — kept here so it is still said once the period bar has scrolled away. */
  aside?: string;
}

// The labelled hairline that opens each of Painel's sections (DESIGN.md, Section Head): the title in Bricolage, a
// rule that fills the row, the period at its end. The heading doubles as the target of a link into the section, so
// it can take focus without a tab stop of its own, and it keeps clear of the phone's fixed top bar when scrolled to.
export const SectionHead: React.FC<SectionHeadProps> = ({ id, title, aside }) => (
  <div className="flex items-center gap-4">
    <h2
      id={id}
      tabIndex={-1}
      className="shrink-0 scroll-mt-20 font-display text-2xl font-bold tracking-tight text-foreground focus:outline-none lg:scroll-mt-6"
    >
      {title}
    </h2>
    <span className="flex-1 border-t border-border/60" aria-hidden="true" />
    {/* May wrap on a narrow phone (a custom range is long) rather than push the page sideways. */}
    {aside && <span className="text-right text-xs tabular-nums text-muted-foreground">{aside}</span>}
  </div>
);
